module.exports = __webpack_public_path__ + "static/media/pixel.6fe988e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/pixel.png
// module id = 271
// module chunks = 0